export const RegExpErrorsText = {
    PHONE: 'Неверный формат телефона',
    EMAIL: 'Неверный формат почты',
    NAME: 'Неверный формат, допускаются Русские буквы, дефис и пробел, от 2-х до 30-ти символов',
    PASSWORD: 'Пароль должен состоять, как минимум, из 6-ти символов. Допускаются использовать латинские буквы в любом регистре, цифры и символы.',
    SNILS: 'Неверный формат снилс. Необходимо указать 11 цифр без дефисов и пробелов.',
    REQUIRED: 'Обязательное поле для заполнения',
};
